import React from "react";
import {
  Grid,
  Typography,
  Box,
  Breadcrumbs,
  Link,
  Theme,
  Chip,
  emphasize,
  useMediaQuery,
  useTheme,
  Button,
  Tooltip,
  Stack,
  FormControlLabel,
  Switch,
  Tabs,
  Tab,
} from "@mui/material";
import { NavLink, useNavigate } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { IBreadcrumbProps } from "./IBreadcrumbProps";
import { AddOutlined, ArrowBack } from "@mui/icons-material";
import styled from "@emotion/styled";
import {
  useBillingCompanyContext,
  useBillingCompanyFromStorage,
} from "../../../providers";
import { CustomStatus } from "../../../components/customStatus/CustomStatus";
import { BillingInfoDialog } from "../../../views/dashboard/Dashboard/BillingInfoDialog";
import { useAuth } from "../../../contexts/AuthProvider/AuthProvider";
import CustomSwitch from "../../../components/customSwitch/customSwitch";
import { TabsList } from "../../../components/Tabs/TabsList";

export const Breadcrumb: React.FC<IBreadcrumbProps> = ({
  subtitle,
  items,
  title,
  children,
  actionButtonText,
  actionButtonIcon,
  onActionButtonClick,
  rightSwitch,
  shouldDisableActionButton = false,
}) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isDesktop = useMediaQuery(theme.breakpoints.up("sm"));
  const {
    user: { affilated_company_outlet_uuids },
  } = useAuth();
  const userBillingInfo = useBillingCompanyContext();
  const [openCompanyInfoDialog, setCompanyInfoDialog] =
    React.useState<boolean>(false);
  return (
    <Box display={"flex"} sx={{ mb: 2 }}>
      <Box
        sx={(theme: Theme) => ({
          pl: 1,
          pr: 1,
          mr: 1,
          display: "flex",
          justifyContent: "left",
          alignItems: "left",
        })}
      >
        <ArrowBack
          color="action"
          sx={{ cursor: "pointer" }}
          onClick={() => navigate(-1)}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
          alignItems: "center",
          flexDirection: "row",
        }}
      >
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography color="textSecondary" fontWeight="400" variant="h4">
            {subtitle}
          </Typography>

          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
          >
            {items
              ? items.map((item) => (
                  <div key={item.title}>
                    {item.to ? (
                      <StyledBreadcrumb
                        component="a"
                        href={item.to}
                        label={item.title}
                      />
                    ) : (
                      <Typography
                        color="textPrimary"
                        textTransform={"capitalize"}
                      >
                        {item.title}
                      </Typography>
                    )}
                  </div>
                ))
              : ""}
          </Breadcrumbs>
          {/* <Typography fontWeight="700" variant="h3">
        {title}
      </Typography> */}
        </Box>
        <Box sx={{ flexShrink: 0, ml: 2 }}>
          <Stack direction={"row"} spacing={2}>
            {onActionButtonClick && (
              <Tooltip
                title={
                  shouldDisableActionButton
                    ? "You have reached the limit to use this action"
                    : ""
                }
                arrow
              >
                <span>
                  <Button
                    variant="contained"
                    onClick={onActionButtonClick}
                    startIcon={
                      actionButtonIcon ? actionButtonIcon : <AddOutlined />
                    }
                    disabled={shouldDisableActionButton}
                  >
                    {actionButtonText}
                  </Button>
                </span>
              </Tooltip>
            )}

            {rightSwitch && (
              <FormControlLabel
                control={
                  <Switch
                    size="medium"
                    checked={rightSwitch.checked}
                    onChange={rightSwitch.onChange}
                    name="gilad"
                  />
                }
                sx={{
                  "& .MuiFormControlLabel-label": {
                    fontWeight: 600,
                    fontSize: "1rem",
                  },
                }}
                label={rightSwitch.label}
              />
            )}

         
          </Stack>
          {/* {userBillingInfo.comapny.company_outlet_name && isDesktop && (
            <Box
              sx={{ cursor: "pointer" }}
              onClick={() => {
                if (affilated_company_outlet_uuids?.length > 1) {
                  setCompanyInfoDialog(true);
                }
              }}
            >
              <CustomStatus
                value={userBillingInfo?.comapny.company_outlet_name}
              />
            </Box>
          )} */}

          {/* {userBillingInfo.comapny.company_outlet_name && isMobile && (
            <Box
              sx={{
                display: "flex",

                backgroundColor: "primary.main",
                color: "#fff",
                fontWeight: 600,
                paddingX: 1,
                paddingY: 0.5,

                ml: "auto",
                borderRadius: 1,
                width: "fit-content",
              }}
              onClick={() => setCompanyInfoDialog(true)}
            >
              <Typography>
                {userBillingInfo?.comapny.company_outlet_name || "--"}
              </Typography>

           
            </Box>
          )} */}
        </Box>
      </Box>
      {openCompanyInfoDialog && (
        <BillingInfoDialog
          open={openCompanyInfoDialog}
          onClose={() => setCompanyInfoDialog(false)}
        />
      )}
    </Box>
  );
};

const StyledBreadcrumb = styled(Chip)(({ theme }: any) => {
  return {
    backgroundColor: theme.palette.primary.main,
    height: theme.spacing(3),
    color: "#fff",
    fontWeight: theme.typography.fontWeightRegular,
    textTransform: "capitalize",
  };
}) as typeof Chip;
